
import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";
import { isSubdomain } from "@/services/common";
import { Home_Link } from "@/constant";
import { API_STORE } from "@/config";
import $ from "jquery";
// global.jQuery = require('jquery');
// var $ = global.jQuery;
// window.$ = $;

const SubmitQuery = () => import("@/components/product/productQuery/Query.vue");
const EmailSubscriber = () =>
  import("@/components/product/emailSubscription/EmailSubscription.vue");

@Component({ components: { SubmitQuery, EmailSubscriber } })
export default class HomeComponent extends Vue {
  public link = Home_Link;

  public contact: any = {
    name: null,
    email: null,
    mobileNumber: null,
    message: null,
  };

  public async contactEmail() {
    let result = await this.$validator.validateAll();
    if (result) {
      let response = await Axios.post(
        API_STORE.PRODUCT + "submitQuery",
        this.contact
      );
      if (response) {
        this.$snotify.success("Your message has been sent successfully");
        this.contact = {};
      }
    } else {
      setTimeout(() => {
        this.clearFields();
      }, 2000);
    }
  }
  public clearFields() {
    this.$validator.errors.items = [];
  }

  public changeClass(idx) {
    this.link = JSON.parse(JSON.stringify(this.link));
    this.link.forEach((l, i1, a) => {
      l.class = "";
    });
    this.link[idx].class = "active";
  }

  public routeToSignUp() {
    this.$router.push("/signup");
  }

  mounted() {
    if (location.href.includes("/#")) {
      window.location.assign("/");
    }

    // Scroll effect
    $(".menu-icon").on("click", function () {
      $("nav ul").toggleClass("showing");
    });

    // Scrolling Effect
    $(window).on("scroll", function () {
      if ($(window).scrollTop()) {
        $("nav").addClass("black");
      } else {
        $("nav").removeClass("black");
      }
    });
  }
}
